/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogLine
 */
export interface LogLine {
    /**
     * 
     * @type {string}
     * @memberof LogLine
     */
    eventId: string;
    /**
     * 
     * @type {Date}
     * @memberof LogLine
     */
    timestamp: Date;
    /**
     * 
     * @type {string}
     * @memberof LogLine
     */
    message: string;
}

/**
 * Check if a given object implements the LogLine interface.
 */
export function instanceOfLogLine(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "eventId" in value;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function LogLineFromJSON(json: any): LogLine {
    return LogLineFromJSONTyped(json, false);
}

export function LogLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogLine {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventId': json['eventId'],
        'timestamp': (new Date(json['timestamp'])),
        'message': json['message'],
    };
}

export function LogLineToJSON(value?: LogLine | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eventId': value.eventId,
        'timestamp': (value.timestamp.toISOString()),
        'message': value.message,
    };
}

